import TimeIcon from "../../../../assets/icons/TimeIcon";
import { capitalize } from "../../../../utils/string";

export default function WorkFlows({
  workflowsData = [],
  isSlaBased,
}: {
  workflowsData?: any[];
  isSlaBased?: boolean;
}) {
  return (
    <div className="my-4">
      <h6 className="text-base text-header font-medium">Workflows</h6>
      <div className="shadow p-4 mt-2 rounded-lg">
        {workflowsData?.map((item) => {
          const totalMinutes = item?.visibility_duration_minutes || 0;
          const hours = Math.floor(totalMinutes / 60);
          const minutes = totalMinutes % 60;
          // const formattedTime = `${hours} Hours`;
          const formattedTime = `${hours} Hours ${minutes} Minutes`;

          return (
            <div key={item.id}>
              <WorkFlowsItem
                isOpen={isSlaBased}
                name={item?.employee?.officialInfo?.name}
                designation={item?.role_type}
                time={formattedTime}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

interface WorkFlowsItemInterface {
  name: string;
  designation: string;
  time: string;
  isOpen?: boolean;
}

const WorkFlowsItem = ({
  name,
  designation,
  time,
  isOpen,
}: WorkFlowsItemInterface) => {
  return (
    <div className="border border-[#D7DFE9] grid grid-cols-3 items-center p-2 rounded mb-2">
      <span className="text-[#2D3643]">{name}</span>
      <span className="text-[#2D3643] text-center">
        {!isOpen ? capitalize(designation) : "L1"}
      </span>
      <span className="flex items-center justify-end gap-1 text-[#455468]">
        <TimeIcon />
        {time}
      </span>
    </div>
  );
};
